<script>
  import axios from "axios";
  import { onDestroy, onMount } from "svelte";
  import { activeClass, link, t, navigateTo, settings } from "../../../../core";
  import type { UserInformationType } from "./user-store";
  import { userInfo } from "./user-store";

  let userName: string = "";

  let userInfoUnsubscribe: () => void;

  onMount(() => {
    userInfoUnsubscribe = userInfo.subscribe(user => {
      userName = user?.name || "";
    })
  })

  onDestroy(() => {
    userInfoUnsubscribe();
  })

  function logout() {
    axios.post("/api/Customer/logout").then(() => {
      location.reload();
    });
  }
</script>

<div class="user-information-wrapper">
  <a
    class="user-information-item"
    use:link
    use:activeClass={"user-information-item--active"}
    href={settings.myProfilePageUrl}
    on:click
  >
    <span class="user-information-item__text">{userName}</span>
    <svg class="icon" width="17" height="17" aria-label={userName}>
      <use xlink:href="#user" />
    </svg>
  </a>

  <button class="user-information-item" on:click={logout}>
    <span class="user-information-item__text">{t("General.Logout.Title")}</span>
    <svg class="icon" width="17" height="17" aria-label="logout">
      <use xlink:href="#logout" />
    </svg>
  </button>
</div>

<style lang="scss">
  .user-information-wrapper {
    display: grid;
    grid-auto-flow: row;
    column-gap: 32px;
    row-gap: 14px;

    @include sm {
      grid-auto-flow: column;
    }
  }

  .user-information-item {
    color: inherit;
    display: flex;
    align-items: center;

    &__text {
      padding-bottom: 2px;
    }

    .icon {
      fill: $key-color;
      min-width: 17px;

      @include md-down {
        order: -1;
        fill: $text-reverse-color;
        margin-right: 8px;
      }

      @include md {
        margin-left: 8px;
      }
    }
  }

  :global(.user-information-item--active) {
    cursor: default;

    .user-information-item__text {
      box-shadow: 0 3px 0 0 $contrast-color;
    }
  }
</style>
